<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>账期管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="账期名称"
                        prop="name">
            <el-input placeholder="请输入名称" clearable
                      v-model="search.name"></el-input>
          </el-form-item>
          <el-form-item label="禁用状态"
                        prop="is_disabled">
              <el-select class="width-max"
                         clearable
                         v-model="search.is_disabled"
                         placeholder="请选择">
                <el-option
                  v-for="(value, key) in {0: '启用中', 1: '已禁用'}"
                  :key="key"
                  :label="value"
                  :value="key">
                </el-option>
              </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/pay-conditions/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加账期
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="name"
                         label="账期名称"
                         min-width="120"></el-table-column>
        <el-table-column prop="payment_term_days"
                         label="账期时间/天"
                         min-width="120"></el-table-column>
        <el-table-column prop="kingdee_number"
                         label="金蝶编码"
                         min-width="120"></el-table-column>
        <el-table-column prop="created_at"
                         label="禁用状态"
                         width="190">
          <template slot-scope="scope">
            {{ scope.row.is_disabled ? '已禁用' : '启用中' }}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="200">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/pay-conditions/detail/${scope.row.id}`">
                <el-button size="mini">查看</el-button>
              </router-link>
              <router-link :to="`/pay-conditions/update/${scope.row.id}`">
                <el-button size="mini"
                           type="primary">修改
                </el-button>
              </router-link>

              <template>
                <el-button v-if="scope.row.is_disabled"
                           type="success"
                           size="mini"
                           @click="changeDisableStatus(true, scope.row.id)">启用
                </el-button>
                <el-button v-else
                           type="danger"
                           size="mini"
                           @click="changeDisableStatus(false, scope.row.id)">禁用
                </el-button>
              </template>

            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      search: {
        id: null,
        name: null,
        is_disabled: null,
      },
      exportHeader: [
        { key: 'id', text: '账期ID' },
        { key: 'name', text: '账期名称' },
        { key: 'kingdee_number', text: '金蝶编码' },
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('queryPayCondition', params)
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    changeDisableStatus (isEnable, id) {
      const msg = isEnable ? '启用' : '禁用'
      this.$confirm('是否' + msg + '该账期?', '提示', {type: 'warning'}).then(() => {
        request.common(isEnable ? 'enablePayCondition' : 'disablePayCondition', {id}).then(() => {
          this.$message.success('操作成功')
          this.onRefresh()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/pay-conditions/pages/PayConditionsTable.vue